import padStart from 'lodash/padStart';

const getTimeInMinutes = (theTime) => {
  theTime = theTime.toLowerCase();
  const times = theTime.match(/(\d+):?(\d+)?\s*(\w)?/);
  let hours = parseInt(times[1], 10);
  const minutes = parseInt(times[2], 10) || 0;
  const meridian = times[3] || times[2];
  if (meridian === 'p' && hours < 12) {
    hours += 12;
  } else if (meridian === 'a' && hours === 12) {
    hours = 0;
  }
  return (hours * 60) + minutes;
};

const visitDuration = (start, end) => {
  const duration = getTimeInMinutes(end) - getTimeInMinutes(start);
  if (duration < 60) {
    return `${duration}min visit`;
  } else if (!(duration % 60)) {
    return `${duration / 60} hr visit`;
  } else {
    return `${Math.floor(duration / 60)}hr ${duration % 60}min visit`;
  }
};

const parseISODate = (isoDate) => {
  if (typeof isoDate === 'string') {
    const dateParts = isoDate.split(/[-T:]/);
    dateParts[1] = parseInt(dateParts[1], 10) - 1;
    return new Date(...dateParts);
  } else {
    return new Date(isoDate);
  }
};

const fairEventDuration = (start, end) => {
  const duration = getTimeInMinutes(end) - getTimeInMinutes(start);
  if (duration < 60) {
    return `${duration}min`;
  } else if (!(duration % 60)) {
    return `${duration / 60} hr`;
  } else {
    return `${Math.floor(duration / 60)}hr ${duration % 60}min`;
  }
};

const formatDateInCancelModal = (start, end, day) => {
  start = start.toUpperCase();
  end = end.toUpperCase();
  if (start.slice(-2) === end.slice(-2)) {
    return `${start.slice(0, -2)}-${end.slice(0, -2)} ${end.slice(-2)} ${day}`;
  } else {
    return `${start.slice(0, -2)} ${start.slice(-2)}-${end.slice(0, -2)} ${end.slice(-2)} ${day}`;
  }
};

const formatDateInExceptionsDeleteModal = (start, end) => {
  start = start.toUpperCase();
  end = end.toUpperCase();
  if (start.slice(-2) === end.slice(-2)) {
    return `${start.slice(0, -2)}-${end.slice(0, -2)} ${end.slice(-2)}`;
  } else {
    return `${start.slice(0, -2)} ${start.slice(-2)}-${end.slice(0, -2)} ${end.slice(-2)}`;
  }
};

const isValidTime = (time) => {
  if (time) {
    return time.search(/((1[0-2])|0?[1-9])(:([0-5][0-9]))?[ ]?[AaPp][Mm]/) !== -1;
  } else {
    return false;
  }
};

const getWeekStart = (date) => new Date(date.getFullYear(), date.getMonth(), (date.getDate() - date.getDay()) + 1);

const getWeekEnd = (date) => new Date(date.getFullYear(), date.getMonth(), (date.getDate() - date.getDay()) + 5, 23, 59, 59);

const getDateString = (date) => `${date.getFullYear()}-${padStart(date.getMonth() + 1, 2, '0')}-${padStart(date.getDate(), 2, '0')}`;

const endBeforeStart = (startTime, endTime) => getTimeInMinutes(startTime) - getTimeInMinutes(endTime) > 0;

export {
  visitDuration,
  formatDateInCancelModal,
  formatDateInExceptionsDeleteModal,
  getTimeInMinutes,
  fairEventDuration,
  getDateString,
  getWeekStart,
  getWeekEnd,
  isValidTime,
  parseISODate,
  endBeforeStart,
};
